import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

// Keep rewards widget code out of the main OWA bundle. It only downloads when
// the flighted Rewards button actually renders.
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "HeaderRewardsWidget"*/ './lazyIndex'),
    { name: 'HeaderRewardsWidget' }
);

export const RewardsMedallionWidget: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.RewardsMedallionWidget
);

export const RewardsMedallionIcon: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.RewardsMedallionIcon
);
